import { useTheme } from '@/core/theme/theme';
import { Icon } from './Icon';
import { cn } from './cn';

/** Light/dark switch. Remembers the choice; until chosen, the OS setting decides. */
export function ThemeToggle({ className }: { className?: string }) {
  const [theme, setTheme] = useTheme();
  const dark = theme === 'dark';
  const label = dark ? 'تغییر به حالت روشن' : 'تغییر به حالت تاریک';
  return (
    <button
      type="button"
      onClick={() => setTheme(dark ? 'light' : 'dark')}
      aria-label={label}
      title={label}
      className={cn('relative grid size-10 place-items-center overflow-hidden rounded-full border border-line bg-paper text-ink transition hover:border-turquoise/50 hover:bg-fill active:scale-90', className)}
    >
      <Icon name="sun" size={19} className={cn('absolute transition duration-300', dark ? 'rotate-0 scale-100 opacity-100' : '-rotate-90 scale-50 opacity-0')} />
      <Icon name="moon" size={19} className={cn('absolute transition duration-300', dark ? 'rotate-90 scale-50 opacity-0' : 'rotate-0 scale-100 opacity-100')} />
    </button>
  );
}
